import Link from '@amzn/meridian/link';
import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import selectReturn from '../../../assets/selectReturn.png';
import underDocuments from '../../../assets/underDocuments.png';
import viewingReturnOrderNavigation from '../../../assets/viewReturnOrderNavigation.png';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import { HelpAlert, HelpBody, HelpImage, HelpStep, HelpTitle } from './HelpElements';

const LocatingCreditMemoHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('locatingCreditMemoHelp');

    return (
        <>
            <HelpTitle>{t('locatingCreditMemoHelp_Title')}</HelpTitle>
            <HelpBody>{t('locatingCreditMemoHelp_purpose')}</HelpBody>
            <HelpStep step={1}>{t('locatingCreditMemoHelp_selectAccount')}</HelpStep>
            <HelpStep step={2}>{t('locatingCreditMemoHelp_viewReturnsNavigation')}</HelpStep>
            <HelpImage src={viewingReturnOrderNavigation} />
            <HelpStep step={3}>{t('locatingCreditMemoHelp_selectReturn')}</HelpStep>
            <HelpImage src={selectReturn} />
            <HelpStep step={4}>{t('locatingCreditMemoHelp_underDocuments')}</HelpStep>
            <HelpImage src={underDocuments} />
            <HelpStep step={5}>{t('locatingCreditMemoHelp_downloadMemo')}</HelpStep>
            <HelpStep step={6}>{t('locatingCreditMemoHelp_findMemoNumber')}</HelpStep>
            <HelpBody>{t('locatingCreditMemoHelp_emailNotification')}</HelpBody>
            <HelpAlert type={'warning'}>
                <Trans
                    i18nKey={'locatingCreditMemoHelp_noMemoContact'}
                    ns={'locatingCreditMemoHelp'}
                    components={{
                        mailto1: <Link href={'mailto:amazon-devices-returns@amazon.com'}>{''}</Link>,
                        mailto2: <Link href={'mailto:ring-returns@amazon.com'}>{''}</Link>,
                    }}
                />
            </HelpAlert>
        </>
    );
};

export { LocatingCreditMemoHelp };
